/* DNA iPhone Duo intro and pre-order banner (AppDeen AI, 21 Oct 2026, mobile fix same day)
 *
 * The intro is live HTML text + a short phone clip. When the clip ends, the real page
 * (already loaded under the overlay) flies out of the DNA icon on the phone, and the phone
 * lands in the iPhone Duo slide of the hero carousel. Then "Pre-orders open" and
 * "Pre-order now" pop and pulse.
 *
 * Mobile fix:
 *  - The clip is downloaded in full (snippet starts it the moment the page starts) and only then
 *    played, so it runs start to finish. Streaming it let slow phones start, stall, and show
 *    only glimpses.
 *  - This file loads async, so it starts as early as possible.
 *  - A visitor is marked "seen" only after the intro actually ran, or they pressed Skip.
 *    Before, a phone that missed the 3 s window was marked seen and never got the intro again.
 *  - If the clip cannot play (iPhone Low Power Mode, blocked autoplay, Data Saver, slow network,
 *    a stall mid-clip) the intro still runs on the same timeline: logo, the three lines, and the
 *    phone picture rises in where the clip would be, then lands in the slide exactly as before.
 *
 * Visitors who have seen it get the normal page and the "Pre-order now" button pulses twice.
 * Reduced motion and bots get the normal page untouched. Nothing here delays the page itself.
 */
(function () {
  'use strict';
  var html = document.documentElement;
  var root = document.getElementById('duo-intro');
  var KEY = 'dnaDuoIntroSeen';
  var EASE_OUT = 'cubic-bezier(.33,1,.68,1)';
  var EASE_IN_OUT = 'cubic-bezier(.65,0,.35,1)';
  var EASE_BACK = 'cubic-bezier(.34,1.56,.64,1)';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var DUR = 6.88;          // clip length, seconds
  var SPLASH = 0.17;       // timeline point where the logo is fully in: shown while the clip loads
  var PHONE_IN = 1.2;      // no-clip version: when the phone picture rises in
  var START_BUDGET = 3000; // ms the clip gets to download before the no-clip version takes over
  var START_GRACE = 1000;  // extra ms when it has downloaded but has not started playing yet
  var STALL_BUDGET = 2000; // ms a stalled clip gets before the no-clip version takes over

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function anim(el, kf, o) { try { return el.animate(kf, o); } catch (e) { return null; } }
  function inView(r) { return r.width > 4 && r.height > 4 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth; }
  function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  /* the script is async, so it can run before, during or after DOMContentLoaded.
     Callbacks run one tick after it, so the carousel (assets/dna-mx.js) is set up first. */
  var domReady = false;
  document.addEventListener('DOMContentLoaded', function () { domReady = true; });
  function domDone() {
    if (domReady || document.readyState === 'complete') return true;
    try {
      var n = performance.getEntriesByType('navigation')[0];
      if (n && n.domContentLoadedEventEnd > 0) domReady = true;
    } catch (e) {}
    return domReady;
  }
  function afterDom(fn) {
    if (domDone()) { fn(); return; }
    var once = false, go = function () { if (!once) { once = true; setTimeout(fn, 0); } };
    document.addEventListener('DOMContentLoaded', go);
    addEventListener('load', go);
  }

  /* ------------------------------------------------ the iPhone Duo slide
   * It is an ordinary "Slide" block in the homepage hero (Theme editor > Hero + side banner),
   * found by its picture: the uploaded file dna-iphone-duo-phone.png. If the team removes the
   * slide or changes the picture, the intro still plays and simply fades into the page. */
  var ART = 'img.mxb-a1[src*="iphone-duo-phone"]';
  function slideParts() {
    var art = $('.mxh-main ' + ART);
    if (!art) return null;
    var slide = art.closest('[data-slide]'), copy = art.closest('.mxb');
    copy = copy && $('.mxb-copy', copy);
    return { slide: slide, art: art, items: copy ? $$('.mxb-copy > *', copy.parentNode) : [] };
  }
  function pulse(el, delay) {
    anim(el, [{ boxShadow: '0 0 0 0 rgba(0,168,216,.55)' }, { boxShadow: '0 0 0 16px rgba(0,168,216,0)' }],
      { duration: 700, delay: delay, easing: 'ease-out' });
  }
  function bannerIn(t0) {           // t0 = ms from now when the copy starts
    var p = slideParts(); if (!p) return;
    var d = t0, cta = null;
    p.items.forEach(function (el) {
      var pop = el.classList.contains('mxb-pill') || el.classList.contains('mxb-cta');
      if (pop) {                      // "Pre-orders open" and "Pre-order now" pop in
        d += 110;
        anim(el, [{ opacity: 0, transform: 'scale(.55)' }, { opacity: 1, transform: 'none' }],
          { duration: 320, delay: d, easing: EASE_BACK, fill: 'backwards' });
        d += 60;
      } else {                        // the other lines rise in
        anim(el, [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }],
          { duration: 340, delay: d, easing: EASE_OUT, fill: 'backwards' });
        d += 75;
      }
      if (el.classList.contains('mxb-cta')) cta = el;
    });
    if (cta) { pulse(cta, d + 450); pulse(cta, d + 1450); }
  }

  if (!root) {                        // no intro on this view (seen it, reduced motion, bot):
    if (!reduce) afterDom(function () { // the copy is already on screen, so only nudge the button
      var q = slideParts();
      var b = q && q.items.filter(function (el) { return el.classList.contains('mxb-cta'); })[0];
      if (b) { pulse(b, 900); pulse(b, 1900); }
    });
    return;
  }

  /* hold the hero carousel on the iPhone Duo slide while the intro runs, using the
     carousel's own hover pause (assets/dna-mx.js), then let it run again */
  var held = false;
  function hero() { return $('.mxh-main'); }
  function hold() {
    var main = hero();
    if (held || !main || !domDone()) return; held = true;
    main.dispatchEvent(new Event('mouseenter'));
    var p = slideParts(), slides = $$('[data-slide]', main), n = p && p.slide ? slides.indexOf(p.slide) : -1;
    var dot = n > 0 && $('[data-dot="' + n + '"]', main);
    if (dot) dot.click();
  }
  function release() {
    var main = hero();
    if (!main) return;
    setTimeout(function () {
      if (!(main.matches && main.matches(':hover'))) main.dispatchEvent(new Event('mouseleave'));
    }, 4500);
  }
  afterDom(hold);
  addEventListener('load', hold);

  /* ------------------------------------------------ the intro */
  var stage = $('.duo-stage', root);
  var video = $('.duo-video', root);
  var skipBtn = $('.duo-skip', root);
  var logo = $('.duo-logo', root);
  var lines = $$('.duo-line > span', root);
  var mode = 'd', scale = 1, W = 1440, H = 900;
  var done = false, revealing = false, raf = 0;
  var playing = false;   // the clip has started
  var running = false;   // the intro is visibly running (clip or no-clip version)
  var liteOn = false;    // the no-clip version took over
  var phone = null;      // no-clip version: the phone picture standing in for the clip

  function layout() {
    var vw = innerWidth, vh = innerHeight;
    mode = vw / vh < 0.8 ? 'm' : 'd';
    W = mode === 'm' ? 416 : 1440;
    scale = Math.min(vw / W, vh / H);
    root.setAttribute('data-mode', mode);
    stage.style.transform = 'translate(-50%,-50%) scale(' + scale + ')';
  }
  function toView(x, y) {           // design units -> viewport px
    return [innerWidth / 2 + (x - W / 2) * scale, innerHeight / 2 + (y - H / 2) * scale];
  }
  // where the clip sits on the stage, in design units
  function videoBox() { return mode === 'm' ? [-225, 173, 865.4] : [0, 0, 1440]; }
  function fromVideo(x, y) {         // clip px (1440 wide) -> design units
    var b = videoBox(), k = b[2] / 1440;
    return [b[0] + x * k, b[1] + y * k];
  }
  // the phone in the clip's last frame, in viewport px: [top-left, bottom-right]
  function phoneBox() {
    var a = fromVideo(216, 284), b = fromVideo(1228, 830);
    return [toView(a[0], a[1]), toView(b[0], b[1])];
  }
  function placePhone(img) {
    var r = phoneBox();
    img.style.left = r[0][0] + 'px'; img.style.top = r[0][1] + 'px';
    img.style.width = (r[1][0] - r[0][0]) + 'px'; img.style.height = (r[1][1] - r[0][1]) + 'px';
  }
  function makePhone(src) {
    var img = document.createElement('img');
    img.className = 'duo-fly'; img.alt = ''; img.src = src;
    img.style.maxWidth = 'none'; img.style.maxHeight = 'none';   // the theme caps img width at 100%, which squeezed it on phones
    placePhone(img);
    return img;
  }
  function onResize() { layout(); if (phone && !revealing) placePhone(phone); }

  /* timeline, seconds on the clip's clock */
  var LOGO = { d: { s0: 279 / 103, dy: 413.5 - 79 }, m: { s0: 175 / 67, dy: 413.5 - 60.5 } };
  var LINES = [[1.12, 1.72, 2.98, 3.33], [3.42, 4.15, 5.12, 5.60], [5.68, 6.33, 6.73, 7.10]];
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function eo(p) { return 1 - Math.pow(1 - p, 3); }
  function eio(p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
  function draw(t) {
    var L = LOGO[mode];
    var a = clamp((t - 0.05) / 0.12);
    var m = eio(clamp((t - 0.73) / 0.80));
    var s = (L.s0 + (1 - L.s0) * m) * (0.92 + 0.08 * eo(a));
    logo.style.opacity = a;
    logo.style.transform = 'translateY(' + (L.dy * (1 - m)) + 'px) scale(' + s + ')';
    lines.forEach(function (el, i) {
      var k = LINES[i], o, y;
      if (t < k[0]) { o = 0; y = 1.05; }
      else if (t < k[1]) { var e = eo((t - k[0]) / (k[1] - k[0])); o = 0.35 + 0.65 * e; y = 1.05 * (1 - e); }
      else if (t < k[2]) { o = 1; y = 0; }
      else if (t < k[3]) { var q = (t - k[2]) / (k[3] - k[2]); o = 1 - 0.15 * q; y = -1.4 * q * q; }
      else { o = 0; y = -1.4; }
      el.style.opacity = o;
      el.style.transform = 'translateY(' + y + 'em)';
    });
  }
  function loop() {
    if (done || liteOn) return;
    draw(Math.max(video.currentTime, SPLASH));   // never drop below the splash, so the logo does not blink
    if (!revealing) raf = requestAnimationFrame(loop);
  }

  /* ------------------------------------------------ the no-clip version */
  function goLite(from) {
    if (liteOn || revealing) return;
    liteOn = true;
    cancelAnimationFrame(raf);
    try { video.pause(); } catch (e) {}
    video.style.visibility = 'hidden';
    $$('source', video).forEach(function (s) { s.parentNode.removeChild(s); });   // stop the download
    try { video.removeAttribute('src'); video.load(); } catch (e) {}
    afterDom(function () { if (!revealing) startLite(from || 0); });
  }
  function startLite(from) {
    hold();
    running = true;
    var p = slideParts();
    if (p && p.art) {
      phone = makePhone(p.art.currentSrc || p.art.src);
      phone.style.opacity = '0';
      document.body.appendChild(phone);
    }
    var t0 = now() - Math.max(from, SPLASH) * 1000, shown = false;
    function tick() {
      if (done || revealing) return;
      var t = (now() - t0) / 1000;
      draw(t);
      if (phone && !shown && t >= PHONE_IN) {
        shown = true;
        anim(phone, [{ opacity: 0, transform: 'translateY(48px)' }, { opacity: 1, transform: 'none' }],
          { duration: t - PHONE_IN > 0.5 ? 300 : 900, easing: EASE_OUT, fill: 'forwards' }) || (phone.style.opacity = '1');
      }
      if (t >= DUR) { draw(DUR); reveal(false); return; }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
  }

  /* ------------------------------------------------ the reveal */
  function pieces() {
    var list = [];
    function add(sel, delay) {
      $$(sel).forEach(function (el, i) {
        var r = el.getBoundingClientRect();
        if (inView(r)) list.push([el, r, typeof delay === 'function' ? delay(i) : delay]);
      });
    }
    add('header.head', 33);
    add('nav.nav', 83);
    add('[id$="__mx_ticker"]', 133);
    add('.mxh-side', 183);
    add('.mxh-main', 233);
    add('nav.mtabs', 333);
    add('[id$="__categories"] .row > *', function (i) { return 267 + 33 * i; });
    add('[id$="__categories"] .rail-nav', 633);
    add('[id$="__mx_cards"] .rail > *', function (i) { return 400 + 50 * i; });
    return list;
  }

  function reveal(fast) {
    if (revealing) return;
    revealing = true;
    if (running) markSeen();           // only once they have actually seen it
    cancelAnimationFrame(raf);
    hold();
    try { video.pause(); } catch (e) {}
    var p = slideParts();
    var finish = function () {
      if (done) return; done = true;
      html.classList.remove('duo-intro-on');
      html.classList.add('duo-intro-done');
      if (root.parentNode) root.parentNode.removeChild(root);
      if (phone && phone.parentNode) phone.parentNode.removeChild(phone);
      if (blobUrl) setTimeout(function () { try { URL.revokeObjectURL(blobUrl); } catch (e) {} }, 0);
      removeEventListener('resize', onResize);
      removeEventListener('keydown', onKey);
      release();
    };
    if (fast || reduce || !p || !p.art || typeof document.body.animate !== 'function') {
      html.classList.remove('duo-intro-on');
      anim(root, [{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' });
      if (phone) anim(phone, [{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' });
      setTimeout(finish, 320);
      if (!reduce) bannerIn(250);
      return;
    }

    // 1. the DNA icon on the phone is where the site comes from
    var ic = fromVideo(1012.5, 495.5), icon = toView(ic[0], ic[1]);
    var ring = document.createElement('div');
    ring.className = 'duo-ring';
    ring.style.left = icon[0] + 'px'; ring.style.top = icon[1] + 'px';
    root.appendChild(ring);

    // 2. swap the clip for the phone cut-out, at exactly the same place
    //    (the no-clip version already has it on screen)
    var box = phoneBox(), s0 = box[0], s1 = box[1];
    var fly = phone || makePhone(p.art.currentSrc || p.art.src);
    if (!fly.parentNode) document.body.appendChild(fly);
    phone = fly;
    video.style.visibility = 'hidden';

    // 2b. where the phone will land: measure now, while the page is still at rest
    var t = p.art.getBoundingClientRect();
    var nw = p.art.naturalWidth || 1012, nh = p.art.naturalHeight || 546;
    var k = Math.min(t.width / nw, t.height / nh);
    var tw = nw * k, th = nh * k;
    var pos = (getComputedStyle(p.art).objectPosition || '50% 50%').split(' ');
    var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
    if (isNaN(px)) px = .5; if (isNaN(py)) py = .5;
    var tx = t.left + (t.width - tw) * px, ty = t.top + (t.height - th) * py;
    var sw = s1[0] - s0[0];
    // the hero clips the picture at its edges (the right hand runs off), so clip the flying copy the same way
    var S = (p.art.closest('.mxh-main') || p.art).getBoundingClientRect(), sc = tw / sw;
    var clip = 'inset(' + [Math.max(0, S.top - ty), Math.max(0, tx + tw - S.right), Math.max(0, ty + th - S.bottom), Math.max(0, S.left - tx)]
      .map(function (v) { return (v / sc).toFixed(1) + 'px'; }).join(' ') + ' round ' + (14 / sc).toFixed(1) + 'px)';

    // 3. the real page flies out of the icon while the white fades
    html.classList.remove('duo-intro-on');
    html.classList.add('duo-revealing');
    anim($('.duo-bg', root), [{ opacity: 1 }, { opacity: 0 }], { duration: 230, delay: 200, easing: 'linear', fill: 'forwards' });
    anim(stage, [{ opacity: 1 }, { opacity: 0 }], { duration: 140, fill: 'forwards' });
    skipBtn.style.display = 'none';
    root.style.pointerEvents = 'none';
    pieces().forEach(function (it) {
      var el = it[0], r = it[1], d = it[2];
      var dx = icon[0] - (r.left + r.width / 2), dy = icon[1] - (r.top + r.height / 2);
      el.style.transformOrigin = '50% 50%';
      anim(el, [{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.04)' }, { transform: 'none' }],
        { duration: 567, delay: d, easing: EASE_OUT, fill: 'backwards' });
      anim(el, [{ opacity: 0 }, { opacity: 1 }], { duration: 125, delay: d, fill: 'backwards' });
    });

    // 4. the phone lands in the iPhone Duo slide (target measured in step 2b, before the page moved)
    anim(fly, [{ transform: 'none', clipPath: 'inset(0px 0px 0px 0px round 0px)' },
               { transform: 'translate(' + (tx - s0[0]) + 'px,' + (ty - s0[1]) + 'px) scale(' + sc + ')', clipPath: clip }],
      { duration: 733, delay: 433, easing: EASE_IN_OUT, fill: 'forwards' });
    setTimeout(function () {
      html.classList.add('duo-landed');
      if (fly.parentNode) fly.parentNode.removeChild(fly);
    }, 433 + 733 + 20);

    // 5. then the copy, "Pre-orders open" and "Pre-order now"
    bannerIn(967);
    setTimeout(function () { html.classList.remove('duo-revealing'); finish(); }, 1400);
  }

  function skip() { markSeen(); reveal(true); }   // they chose to skip: do not show it again
  function onKey(e) { if (e.key === 'Escape') skip(); }

  /* ------------------------------------------------ start */
  layout();
  draw(SPLASH);                       // DNA logo on white while the clip loads
  addEventListener('resize', onResize);
  addEventListener('keydown', onKey);
  skipBtn.addEventListener('click', skip);

  video.addEventListener('playing', function () {
    if (liteOn || revealing) return;
    playing = running = true;
    cancelAnimationFrame(raf); raf = requestAnimationFrame(loop);
  });
  video.addEventListener('ended', function () {
    if (liteOn) return;
    draw(video.duration || DUR); reveal(false);
  });
  video.addEventListener('waiting', function () {
    if (!playing || liteOn) return;
    var at = video.currentTime;
    setTimeout(function () {
      if (!liteOn && !revealing && video.readyState < 3) goLite(at);   // stalled: carry on without the clip
    }, STALL_BUDGET);
  });

  var clipReady = false, blobUrl = '';
  function playFrom(url) {
    if (liteOn || revealing) return;
    clipReady = true;
    video.src = url;
    var pr;
    try { pr = video.play(); } catch (e) { goLite(0); return; }
    if (pr && pr.catch) pr.catch(function () { goLite(0); });   // autoplay blocked (iPhone Low Power Mode, some in-app browsers)
  }

  if (root.hasAttribute('data-lite')) {
    goLite(0);                        // Data Saver: same intro, no clip download
  } else {
    var src = video.getAttribute('data-src');
    if (window.dnaDuoClip) {          // the whole clip, downloaded by the snippet
      window.dnaDuoClip.then(function (blob) {
        if (liteOn || revealing) return;
        if ((blob.type || '').indexOf('video/') !== 0) blob = new Blob([blob], { type: 'video/mp4' });
        playFrom(blobUrl = URL.createObjectURL(blob));
      }, function () { if (src) playFrom(src); else goLite(0); });   // download failed: stream it instead
    } else if (src) {
      playFrom(src);                  // very old browser: stream it
    } else {
      goLite(0);
    }
    setTimeout(function () {          // clip too slow to arrive: same intro without it, no half-played clip
      if (playing) return;
      if (!clipReady) goLite(0);
      else setTimeout(function () { if (!playing) goLite(0); }, START_GRACE);
    }, START_BUDGET);
  }
  setTimeout(function () { if (!revealing) reveal(true); }, 16000);       // never trap anyone
})();
